<table class="skeleton-table" [attr.data-qa]="testId">
  <thead>
    <tr [style.height]="headerHeight">
      @for (column of headerCells; track $index) {
        <th>
          <div class="skeleton-element cell-skeleton"></div>
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of rows; track $index) {
      <tr [style.height]="rowHeight">
        @for (cell of cells; track $index) {
          <td>
            <div class="skeleton-element cell-skeleton"></div>
          </td>
        }
      </tr>
    }
  </tbody>
</table>
